// require js to bundle
var $ = require("jquery");
window.$ = window.jQuery = $;

var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
// make Isotope a jQuery plugin https://isotope.metafizzy.co/extras.html#webpack
jQueryBridget( 'isotope', Isotope, $ );

require('./jquery.once.min');
require('./jquery.fitvids');
require('./jquery.magnific-popup.min');
require('./jquery.viewportchecker.min');
require('./unslider.min');
require('./theia-sticky-sidebar.min');
require('./jquery.basictable.min');
require('./jquery.mmenu.all');
require('../hottopics');
require('../tooltips');
require('./gauze');
require('./form-support');
require('./scripts');
require('./faq-item');
require('./reviews-carousel');
require('./awards-carousel');
require('./quote-carousel');
require('./homepage-news-carousel');
require('./research-carousel');
require('./research-alerts-carousel');
require('./tenable-vs-msft-slider');
require('./tabs-collapsible');
require('./tabs-filterable');
require('./tabs-tabbable');
require('./homepage-testimonials');
require('./simple-tabs');
require('./change-tabs');
require('./tiles-slider');
require('./sticky-nav');
require('./css-animations');
require('./accordion');
require('./prefill-form-email');
